import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const Pipe: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--pipe')}
    id="chart"
    width="10"
    height="25"
    data-icon={icon}
  >
    <line x1="5" y1="4" x2="5" y2="14" stroke="black" strokeWidth="1" />
  </svg>
);

export default Pipe;
